import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { regOrder } from '../Services/api';
import { useTranslation } from 'react-i18next';
import QrModal from '../Components/QrModal';
import './AddOrderScreen.css';

const models = [
    { id: 'K10S', image: './res/svg/maquinas/K10T.svg' },
    { id: 'K10T', image: './res/svg/maquinas/K10T.svg' },
    { id: 'K10', image: './res/svg/maquinas/K10.svg' },
    { id: 'K9T', image: './res/svg/maquinas/K9T.svg' },
    { id: 'K9', image: './res/svg/maquinas/K9.svg' },
    { id: 'K7', image: './res/svg/maquinas/K8.svg' },
    { id: 'K8', image: './res/svg/maquinas/K8.svg' },
    { id: 'K6', image: './res/svg/maquinas/K6.svg' },
];

const AddOrderScreen = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { selectedFeria } = location.state || {};
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [cliente, setCliente] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codPostal, setCodPostal] = useState('');
    const [poblacion, setPoblacion] = useState('');
    const [provincia, setProvincia] = useState('');
    const [pais, setPais] = useState('');
    const [telefono, setTelefono] = useState('');
    const [email, setEmail] = useState('');
    const [modelo, setModelo] = useState('K10S');
    const [observaciones, setObservaciones] = useState('');
    const [condiciones, setCondiciones] = useState('');
    const [vendedor] = useState(localStorage.getItem('userCode') || '');
    const [usuarioId] = useState(localStorage.getItem('userId') || '');
    const [feriaId] = useState(selectedFeria || '');
    const [showModal, setShowModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [autocompleteService, setAutocompleteService] = useState(null);
    const [showQrReader, setShowQrReader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!window.google) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCzPSVkRtifBCXsS_9q7808MvaMbb2PCJM&libraries=places&callback=initAutocomplete`;
            script.async = true;
            script.defer = true;
            window.initAutocomplete = () => {
                const autocompleteService = new window.google.maps.places.AutocompleteService();
                setAutocompleteService(autocompleteService);
            };
            document.body.appendChild(script);
        } else if (!autocompleteService) {
            const autocompleteService = new window.google.maps.places.AutocompleteService();
            setAutocompleteService(autocompleteService);
        }
    }, [autocompleteService]);

    const handleAddOrder = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem('token');
        const orderData = {
            fecha,
            cliente,
            direccion,
            codPostal,
            poblacion,
            provincia,
            pais,
            telefono,
            email,
            modelo,
            observaciones,
            condiciones,
            feriaId,
            vendedor,
            usuarioId
        };
        try {
            await regOrder(orderData, token);
            navigate('/main', { replace: true });
        } catch (error) {
            console.error('Error adding order:', error);
        }
    };

    const handleClose = () => {
        navigate('/main');
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        if (!autocompleteService) return;
        autocompleteService.getPlacePredictions({ input: query }, (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                setSearchResults(predictions);
            }
        });
    };

    const handleSelectAddress = (address) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: address.place_id }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
                const addressComponents = results[0].address_components;
                const getAddressComponent = (type) => addressComponents.find(component => component.types.includes(type))?.long_name || '';
                setDireccion(getAddressComponent('route') + ' ' + getAddressComponent('street_number'));
                setCodPostal(getAddressComponent('postal_code'));
                setPoblacion(getAddressComponent('locality'));
                setProvincia(getAddressComponent('administrative_area_level_1'));
                setPais(getAddressComponent('country'));
                setShowModal(false);
            }
        });
    };

    const parseVCard = (vCard) => {
        const lines = vCard.split('\n');
        const contactInfo = {};
        lines.forEach(line => {
            if (line.startsWith('FN;') && line.includes(':')) {
                contactInfo.name = line.split(':')[1];
            } else if (line.startsWith('TEL;')) {
                contactInfo.phone = line.split(':')[1];
            } else if (line.startsWith('EMAIL;')) {
                contactInfo.email = line.split(':')[1];
            } else if (line.startsWith('ADR;')) {
                const addressParts = line.split(':')[1].split(';');
                contactInfo.address = addressParts[2];
                contactInfo.city = addressParts[3];
                contactInfo.postalCode = addressParts[5];
                contactInfo.country = addressParts[6];
            }
        });
        return contactInfo;
    };

    const handleScan = (decodedText) => {
        console.log(decodedText);
        const contactInfo = parseVCard(decodedText);
        setCliente(contactInfo.name || '');
        setDireccion(contactInfo.address || '');
        setCodPostal(contactInfo.postalCode || '');
        setPoblacion(contactInfo.city || '');
        setPais(contactInfo.country || '');
        setTelefono(contactInfo.phone || '');
        setEmail(contactInfo.email || '');
    };

    return (
        <>
            <div className='add-order-screen'>
                <div className='header'>
                    <button type='button' className='qr-button' onClick={() => setShowQrReader(true)}>
                        <img src='./res/svg/qr_scanner_icon.svg' alt='Scan QR' />
                    </button>
                    <h1>{t('addOrder')}</h1>
                    <button className='close-button' onClick={handleClose}>
                        <img src='./res/svg/close_icon.svg'></img>
                    </button>
                </div>
                <div className='hdivider' />
                <form className='add-order-form' onSubmit={handleAddOrder}>
                    <div className='form-container'>
                        <div className='form-section'>
                            <h2>{t('customerData')}</h2>
                            <label>{t('fecha')}</label>
                            <input type='date' value={fecha} onChange={(e) => setFecha(e.target.value)} required />
                            <label>{t('cliente')}</label>
                            <input type='text' value={cliente} onChange={(e) => setCliente(e.target.value)} required />
                            <label>{t('direccion')}</label>
                            <div className='address-input-container'>
                                <input type='text' value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                <button type='button' className='search-button' onClick={() => setShowModal(true)}>
                                    <img src='./res/svg/location_icon.svg' alt='Search' />
                                </button>
                            </div>
                            <label>{t('codPostal')}</label>
                            <input type='text' value={codPostal} onChange={(e) => setCodPostal(e.target.value)}  />
                            <label>{t('poblacion')}</label>
                            <input type='text' value={poblacion} onChange={(e) => setPoblacion(e.target.value)}  />
                            <label>{t('provincia')}</label>
                            <input type='text' value={provincia} onChange={(e) => setProvincia(e.target.value)}  />
                            <label>{t('pais')}</label>
                            <input type='text' value={pais} onChange={(e) => setPais(e.target.value)} />
                            <label>{t('telefono')}</label>
                            <input type='text' value={telefono} onChange={(e) => setTelefono(e.target.value)} required />
                            <label>{t('email')}</label>
                            <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className='form-section'>
                            <h2>{t('machineData')}</h2>
                            <label>{t('modelo')}</label>
                            <div className='model-selection'>
                                {models.map((model) => (
                                    <div
                                        key={model.id}
                                        className={`model-card ${modelo === model.id ? 'selected' : ''}`}
                                        onClick={() => setModelo(model.id)}
                                    >
                                        <img src={model.image} alt={model.id} />
                                        <p>{model.id}</p>
                                    </div>
                                ))}
                            </div>
                            <label>{t('observaciones')}</label>
                            <textarea value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                            <label>{t('condiciones')}</label>
                            <textarea value={condiciones} onChange={(e) => setCondiciones(e.target.value)} />
                        </div>
                    </div>

                    <div className='submit-button-container'>
                        <button type='submit'>{t('addOrderButton')}</button>
                    </div>
                </form>

                {showModal && (
                    <div className='modal'>
                        <div className='modal-content'>
                            <button className='close-button' onClick={() => setShowModal(false)}>x</button>
                            <h2>{t('searchAddress')}</h2>
                            <input
                                type='text'
                                value={searchQuery}
                                onChange={(e) => handleSearch(e.target.value)}
                                placeholder={t('enterAddress')}
                            />
                            <ul className='search-results'>
                                {searchResults.map((result) => (
                                    <li key={result.place_id} onClick={() => handleSelectAddress(result)}>
                                        {result.description}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                {showQrReader && (
                    <QrModal triggerID="qr-modal" onClose={() => setShowQrReader(false)} onScan={handleScan} />
                )}
            </div>
        </>
    );
};

export default AddOrderScreen;
